import React, { useRef } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PhotoCarousel from "../flight-brief/PhotoCarousel";
import CloseCross from "../ui/CloseCross";

/**
 * Renders the aircraft card image column: photo carousel and price-info notifications.
 */
const AircraftCardImages = ({ photoData, messages, onClearMessages }) => {
    const thumbMessage1 = useRef();
    const thumbMessage2 = useRef();

    return (
        <div className="aircraft-card__image-column">
            <div className="aircraft-card__photos-browser">
                <PhotoCarousel photoData={photoData} />

                <TransitionGroup>
                    {messages.map((message) => (
                        <CSSTransition
                            nodeRef={message.id % 2 === 0 ? thumbMessage1 : thumbMessage2}
                            timeout={450}
                            key={message.id}
                            classNames={{
                                enterActive: "aircraft-card__notification--entering",
                                enterDone: "aircraft-card__notification--enter-done",
                                exitActive: "aircraft-card__notification--exiting",
                            }}
                        >
                            <div
                                ref={message.id % 2 === 0 ? thumbMessage1 : thumbMessage2}
                                className="aircraft-card__notification"
                            >
                                {message.text}
                                <div className="aircraft-card__notification__close-wrapper">
                                    <CloseCross onClick={onClearMessages} />
                                </div>
                            </div>
                        </CSSTransition>
                    ))}
                </TransitionGroup>
            </div>
        </div>
    );
};

export default AircraftCardImages;
